import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-skeleton-block',
  standalone: true,
  template: `<div class="skeleton-block" [style.width]="width" [style.height]="height" [style.border-radius]="borderRadius"></div>`,
  styleUrls: ['./skeleton-block.component.scss'],
})
export class SkeletonBlockComponent {
  @Input() width = '100%';
  @Input() height = '1em';
  @Input() borderRadius = '4px';
}
